import {
    useCallback,
} from 'react'

import useConfirmInstallation from '@src/api/hooks/useConfirmInstallation'
import {
    PhotoType,
} from '@src/context/PhotosContext/PhotosContext'
import usePhotoContext from '@src/context/PhotosContext/usePhotoContext'
import useFlowRouter from '@src/shared-components/FlowRouter/useFlowRouter'

const convertPhotoTypeForRequest = (results: PhotoType[]) => {
    return results.map((result: PhotoType) => {
        return result.filePath || ''
    })
}
const useConfirmGatewayInstallation = (onSuccess:()=> void) => {
    const {
        state,
    } = useFlowRouter()
    const {
        photos: contextPhotos,
        cleanUp,
    } = usePhotoContext()
    const afterSuccess = useCallback(() => {
        cleanUp()
        onSuccess()
    }, [
        onSuccess,
        cleanUp,
    ])
    const onError = useCallback(() => {
        cleanUp()
    }, [cleanUp])
    const {
        mutate: confirmInstallationMutate,
        isPending: isLoading,
        error,
        reset: resetErrors,
    } = useConfirmInstallation(afterSuccess, onError)

    const confirm = useCallback(({
        latitude, longitude,
    }:{
        latitude: number,
        longitude: number,
    }) => {
        confirmInstallationMutate({
            gatewayImeiMac: state.gatewayMac || '',
            email: state.email || '',
            body: {
                gatewayImagesPaths: convertPhotoTypeForRequest(contextPhotos),
                latitude: latitude ?? 0,
                longitude: longitude ?? 0,
            },
        })
    }, [
        state.gatewayMac,
        state.email,
        confirmInstallationMutate,
        contextPhotos,
    ])

    return {
        error,
        isLoading,
        confirm,
        resetErrors,
    }
}

export default useConfirmGatewayInstallation
